import React from "react";
import { getProductInventoryQty } from "../../../utils/inventoryDisplay";

export function ProductNameFormatter(cellContent, row) {
    const desc = row.description != null ? String(row.description).trim() : "";
    const title = desc || row.name;

    return (
        <>
            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                {title}
            </span>
            <span className="text-muted font-weight-bold">
                {row.sku}
            </span>
        </>
    );
}

export function SupplierFormatter(cellContent, row) {
    return (
        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
            {row.supplierName || 'N/A'}
        </span>
    );
}

export function CategoryFormatter(cellContent, row) {
    return (
        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
            {row.productCategory && row.productCategory.length > 0 ? row.productCategory[0].name : 'N/A'}
        </span>
    );
}

export function QuantityFormatter(cellContent, row) {
    const qty = getProductInventoryQty(row);
    const isLowStock = qty < 10;
    
    return (
        <>
            <span className={`text-dark-75 font-weight-bolder d-block font-size-lg ${isLowStock ? 'text-danger' : ''}`}>
                {qty.toLocaleString()}
            </span>
        </>
    );
}

export function PriceFormatter(cellContent, row) {
    const price = parseFloat(row.price) || 0;
    
    return (
        <>
            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                ${price.toFixed(2)}
            </span>
            
        </>
    );
}

export function StatusFormatter(cellContent, row) {
    const isActive = row.isActive;
    
    return (
        <span className={`label label-lg ${isActive ? 'label-light-success' : 'label-light-danger'} label-inline`}>
            {isActive ? 'Active' : 'Inactive'}
        </span>
    );
}
